export const TRAVEL_LOG_EMPTY_DISTANCE_STATUSES = new Set([
    'IN_PROGRESS',
    'HOLD',
    'COMPLETED',
    'REJECTED',
    'CLOSED',
]);

export const shouldShowEmptyTravelLogAction = (distanceTravelled, status) => {
    return Number(distanceTravelled) <= 0
        && TRAVEL_LOG_EMPTY_DISTANCE_STATUSES.has(status?.trim().toUpperCase());
};
